import {
    addToSelection,
    clearSelection,
    removeFromSelection,
} from '../reducers';

import {selectionSelector} from '../selectors';

import {
    useAppDispatch,
    useAppSelector
} from '../../../hooks/useTypedReactRedux';

import {Product} from '../types';

// Selection lives in the Redux selection slice (FNP-951) — never a module-level
// singleton or component useState. The slice stores a map keyed by record id;
// this hook exposes it as the array the table/header/delete-button already use.
export const useProductsSelection = () => {
    const dispatch = useAppDispatch();

    const selection = useAppSelector(selectionSelector);

    const selectedRecords: Product[] = Object.values(selection);

    const setSelectedRecords = (records: Product[]) => {
        const nextIds = new Set(records.map(record => record.id));

        Object.keys(selection)
              .filter(id => !nextIds.has(id))
              .forEach(id => dispatch(removeFromSelection(id)));

        records.filter(record => typeof selection[record.id] === 'undefined')
               .forEach(record => dispatch(addToSelection(record)));
    };

    const handleClearSelection = () => {
        dispatch(clearSelection());
    };

    return {
        selection,
        selectedRecords,
        setSelectedRecords,
        handleClearSelection,
        hasSelection: selectedRecords.length > 0,
    };
};
